import { useEffect } from 'react';
import { Card, Icon } from '@nimbus-ds/components';
import { ChevronDownIcon } from '@nimbus-ds/icons';
import { PaymentProviderDto } from '@tiendanube/common';
import { muvemPagoOrPagoNubeIds } from '@tiendanube/common/src/domains/payments/providers/PaymentProvidersCode';
import { MethodNameAndImage, Stack } from 'commons/components';
import { useModal } from 'commons/hooks';
import { usePatchProviderStatusForNuvemPagoBrasil } from 'domains/Payments/PaymentProviders/hooks';
import { PaymentProviderBody } from './components';
import Skeleton from './Skeleton';
import { OnPaymentProviderActionType } from '../PaymentProviderActionModal';
import { PaymentProviderStatusLabel } from '../PaymentProviderStatusLabel';
import './PaymentProviderMobile.scss';

type PaymentProviderMobileProps = {
  paymentProvider: PaymentProviderDto;
  onAction: OnPaymentProviderActionType;
};

function PaymentProviderMobile({
  paymentProvider,
  onAction,
}: Readonly<PaymentProviderMobileProps>) {
  const { id, logo } = paymentProvider;

  const isNuvemPagoOrPagoNube = muvemPagoOrPagoNubeIds.includes(id);
  const [expand, setExpand, setClose] = useModal(
    isNuvemPagoOrPagoNube || false,
  );

  const { isNuvemPagoBr, providerStatusLabelProps, trackProviderStatus } =
    usePatchProviderStatusForNuvemPagoBrasil(paymentProvider);

  const {
    isActive,
    mustCompleteInstallation,
    processingInstallation,
    isDeprecated,
    isNew,
  } = isNuvemPagoBr ? providerStatusLabelProps : paymentProvider;

  useEffect(() => {
    if (isNuvemPagoBr) {
      trackProviderStatus();
    }
  }, [isNuvemPagoBr, trackProviderStatus]);

  return (
    <Card>
      {!expand && (
        <Card.Header>
          <Stack justify="space-between">
            <MethodNameAndImage
              image={logo}
              isPagoNube={isNuvemPagoOrPagoNube}
            />
            <Stack>
              <PaymentProviderStatusLabel
                isActive={isActive}
                mustCompleteInstallation={mustCompleteInstallation}
                processingInstallation={processingInstallation}
                isNew={isNew}
                isDeprecated={isDeprecated}
              />
              <Icon
                onClick={setExpand}
                color="neutral-textHigh"
                source={<ChevronDownIcon />}
                cursor="pointer"
              />
            </Stack>
          </Stack>
        </Card.Header>
      )}
      {expand && (
        <PaymentProviderBody
          onAction={onAction}
          onClose={setClose}
          paymentProvider={paymentProvider}
        />
      )}
    </Card>
  );
}

PaymentProviderMobile.Skeleton = Skeleton;

export default PaymentProviderMobile;
